/* tjs <- configure-tjs.ts */

/* line 5 */
export function configureTjs(config) {
    const g = globalThis;
    if (g.__tjs?.configure) {
        g.__tjs.configure(config);
    }
    else {
        g.__tjs = { ...g.__tjs, getConfig: () => config };
    }
}
configureTjs.__tjs = {
  "params": {
    "config": {
      "type": {
        "kind": "object",
        "shape": {
          "throwTypeErrors": {
            "kind": "boolean"
          },
          "logTypeErrors": {
            "kind": "boolean"
          }
        }
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "configure-tjs.ts:4"
}